import Universal from 'assets/icons/fa/compass-regular.svg'

Universal.displayName = 'Universal'
export default Universal
